import React from 'react';

const About = () => {
  return (
    <div className="pt-20 min-h-screen bg-gray-50">
      {/* About Banner */}
      <div className="bg-aqua-600 text-white py-24">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold mb-4">About Us</h1>
          <p className="text-xl max-w-3xl mx-auto font-playfair italic">
            "For Events That Speak Elegance"
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-16">
        {/* Our Story Section */}
        <div className="max-w-4xl mx-auto mb-16">
          <h2 className="text-3xl font-playfair font-bold mb-6 text-gray-800 text-center">Our Story</h2>
          <div className="space-y-6 text-gray-600">
            <p className="leading-relaxed">
              At Divine Concepts by Margie, we believe every event is more than just a celebration—it's a story waiting to be told with elegance, meaning, and style. Founded by Margret Mudonda Ilunga Longwe, Divine Concepts is a passion-driven event styling and hire service that turns your special moments into timeless memories.
            </p>
            <p className="leading-relaxed">
              From weddings, kitchen parties, chilanga mulilo, to church functions, baby showers to birthday parties, corporate events and workshops, we specialize in creating beautiful atmospheres that reflect your vision and personality. With a keen eye for detail, a graceful approach to styling, and a commitment to excellence, our goal is simple: To deliver events that speak elegance.
            </p>
            <p className="leading-relaxed">
              Whether you need curated décor, quality event hire, or full styling support, we are here to bring your vision to life—gracefully, creatively, and blissfully.
            </p>
          </div>
        </div>

        {/* Values Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="text-center p-6">
            <div className="bg-gold-50 rounded-full p-4 w-16 h-16 mx-auto mb-4">
              <svg className="w-8 h-8 text-aqua-600 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                  d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-2">Quality Assurance</h3>
            <p className="text-gray-600">
              We maintain the highest standards in our equipment and services, ensuring your event runs smoothly.
            </p>
          </div>
          <div className="text-center p-6">
            <div className="bg-gold-50 rounded-full p-4 w-16 h-16 mx-auto mb-4">
              <svg className="w-8 h-8 text-aqua-600 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-2">Punctuality</h3>
            <p className="text-gray-600">
              Time is crucial in event planning. We guarantee on-time delivery and setup for every rental.
            </p>
          </div>
          <div className="text-center p-6">
            <div className="bg-gold-50 rounded-full p-4 w-16 h-16 mx-auto mb-4">
              <svg className="w-8 h-8 text-aqua-600 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                  d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-2">Customer Satisfaction</h3>
            <p className="text-gray-600">
              Your satisfaction is our priority. We go above and beyond to exceed your expectations.
            </p>
          </div>
        </div>

        {/* Team Section */}
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-playfair font-bold mb-6 text-gray-800 text-center">Our Team</h2>
          <p className="text-gray-600 text-center mb-12">
            Our dedicated team of professionals works tirelessly to ensure your event's success. From our experienced
            event coordinators to our skilled setup crew, each member brings expertise and passion to their role.
          </p>
          
          {/* Add team member cards here if needed */}
        </div>
      </div>

      {/* Call to Action Section */}
      <div className="bg-aqua-50 rounded-lg p-12 text-center mt-16">
        <h2 className="text-3xl font-playfair font-bold mb-4 text-gray-800">Let's Create Something Beautiful</h2>
        <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
          Ready to transform your event into an unforgettable experience?
        </p>
        <button 
          onClick={() => window.location.href = '/contact'}
          className="bg-gold-500 text-white px-8 py-3 rounded-full font-medium hover:bg-gold-600 transition duration-300"
        >
          Get in Touch
        </button>
      </div>
    </div>
  );
};

export default About;